/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Notification object containing code and additional payload data.\\ For TOKEN_EXPIRED_IN_SECONDS, contains seconds until expiration.\\ For other types, may be empty. 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * Notification code identifier\\ TOKEN_EXPIRED_IN_SECONDS: Token will expire within n seconds, payload is the number of seconds\\ TOKEN_EXPIRED: Token has already expired\\ JOB_FAILED: Job processing has failed\\ CREDIT_CONNECT_POSSIBLE: Credit connection is possible for this bank. If user\'s entity is capital, it\'s not shown\\ CREDIT_ALREADY_CONNECTED: Credit connection is already connected for user\'s bank. If user\'s entity is capital, it\'s not shown 
     * @type {string}
     * @memberof Notification
     */
    'code': NotificationCodeEnum;
    /**
     * Additional data for the notification. 
     * @type {Array<string>}
     * @memberof Notification
     */
    'payload': Array<string>;
}

export const NotificationCodeEnum = {
    tokenExpiredInSeconds: 'TOKEN_EXPIRED_IN_SECONDS',
    tokenExpired: 'TOKEN_EXPIRED',
    jobFailed: 'JOB_FAILED',
    creditConnectPossible: 'CREDIT_CONNECT_POSSIBLE',
    creditAlreadyConnected: 'CREDIT_ALREADY_CONNECTED'
} as const;

export type NotificationCodeEnum = typeof NotificationCodeEnum[keyof typeof NotificationCodeEnum];


